import { render, staticRenderFns } from "./FlowButton.vue?vue&type=template&id=baa6bd4c"
import script from "./FlowButton.vue?vue&type=script&lang=js"
export * from "./FlowButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports